<template>
	<div v-html="html">
	</div>

	<div v-if="!received" class="col-lg-8">
		<div class="activity-list ">
			<div class="activity-item text-block">
				Идёт загрузка страницы
			</div>
		</div>
	</div>

	<div v-if="isError" class="col-lg-8">
		<div class="activity-list ">
			<div class="activity-item text-block">
				При загрузке страницы произошла ошибка {{ error }}
			</div>
		</div>
	</div>
</template>

<script>
import { getDataJson } from '@/api/getData'
import { getConfig } from '@/auth'

export default {
	data() {
		return {
			html: '',
			page: 'main',
			received: false,
			isError: false,
			error: ''
		}
	},
	created() {
		let apiPages = getConfig().apiPages

		getDataJson(`${apiPages}?code=${this.page}`)
			.then(x => {
				this.html = x.html
				this.received = true;
			})
			.catch(x => {
				this.isError = true
				this.error = x + ''
			})
	},
}
</script>